import { CTVModel } from '../../Models/ctv-model';
import { Utilities } from 'src/app/utilities';
import { ActionModel } from 'src/app/Models/action-model';
import { WebObjectModel } from 'src/app/Models/web-object-model';


export class CTVMock {
    private static models: CTVModel[];
    private static  idCounter = 0;

    public static initMocks(){
      CTVMock.models = [];
      let am= new ActionModel();
        am.name="weggmccgygyygg";
        am.accepts=["target","value"];                                                                                                                                                                                                                    

      let wo=new WebObjectModel();
      wo.name="UserNameInput"
      // CTVMock.models.push({_id:"ebetbeetttbt", commandSteps_id:++this.idCounter,seq_no:0,  name:"CTV1" , command:am, target:wo, value:"col1", _type:"ctv"});
/*       CTVMock.models.push({id:"wvwverbt4b4tb",commandSteps_id:++this.idCounter,  name:"CTV2", command:"jhegumygt44756", target:"gffnweftewf7775", value:"", _type:"ctv"});
      CTVMock.models.push({id:"tcyyn6n6y56nu",commandSteps_id:++this.idCounter,  name:"CTV3", command:"weggmccgygyygg", target:"eofoefoefjof", value:"col2", _type:"ctv"});
      CTVMock.models.push({id:"fwrgrrrhrhrrr",commandSteps_id:++this.idCounter,  name:"CTV4", command:"erjwwmbwbgbwe4", target:"eofoefoefjof", value:"", _type:"ctv"});
 */    }

    public static findByObjectId(id: string):CTVModel{
      let m = CTVMock.models;
      for(let i = 0; i< m.length; i++){
        if(id == m[i]._id) return m[i];
      }
      return null;
    }

    public static addNewStep(step: CTVModel){
      step._id = Utilities.makeid(10);
      step.commandSteps_id = ++this.idCounter;
      CTVMock.models.push(step);
    }

    public static findById(id:number):CTVModel{
      let m = CTVMock.models;
      for(let i = 0; i< m.length; i++){
        if(id == m[i].commandSteps_id) return m[i];
      }
      return null;
    }
    public static getItems():CTVModel[]{
      return CTVMock.models;
    }
    
}
